export const DEFAULT_STATE = {
    data: null,
    recordEdit: null,
    metadata: null,
    csvdata: null,
    grandTotal: [],
    isGtLoading: false,
    isLoading: false,
};
